import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 4v12a4 4 0 0 1 -4 4h-2a4 4 0 0 1 -4 -4","key":"svg-0"}]]

/**
 * IconLetterJ
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbGV0dGVyLWoiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTE3IDR2MTJhNCA0IDAgMCAxIC00IDRoLTJhNCA0IDAgMCAxIC00IC00IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/letter-j
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconLetterJ = createReactComponent('outline', 'letter-j', 'LetterJ', __iconNode);

export default IconLetterJ;